module.exports = __webpack_public_path__ + "img/01.b8c3f5a2.jpg";